import axiosInstance from "../config/axiosInterceptor";

export async function calculateRoute(payload) {
  return await axiosInstance.post("/api/Routing/calculate", payload);
}
